var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-group"},_vm._l((_vm.statusIconConfigList),function({value, label, icon}){return _c('span',{key:value,attrs:{"label":value}},[_vm._v(" "+_vm._s(_vm.$t(`common.statusMap[${value}]`))+" "),_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":icon[_vm.iconType]}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }